import React, { useContext, useState } from "react";
import AppContext from "../../store/app-context";
import ButtonCircle from "../ButtonCircle/ButtonCircle";

import styles from "./form.module.css";

const Form = ({ content }) => {
  const [toggle, setToggle] = useState("closed");
  const appCtx = useContext(AppContext);

  const toggleButton = () => {
    const el = document.getElementById("menu");
    el.setAttribute("data-mfb-state", toggle);
    const newToggle = toggle === "open" ? "closed" : "open";
    setToggle(newToggle);
  };

  return (
    <>
      <ButtonCircle />
      <p className={styles.intro}>{content.intro}</p>
      <div className={styles.actions}>
        {appCtx.category === "satisfy" && (
          <ul
            id="menu"
            className={styles["mfb-zoomin"]}
            data-mfb-toggle="hover"
            onClick={toggleButton}
          >
            <li className={styles["mfb-component__wrap"]}>
              <button className={styles["mfb-component__button--main"]}>
                Sales
              </button>
              <ul className={styles["mfb-component__list"]}>
                <li>
                  <button
                    className={styles["mfb-component__button--child"]}
                    onClick={() =>
                      appCtx.handleSelectDivison(3, "sales-prospect")
                    }
                  >
                    Calon Konsumen
                  </button>
                </li>
                <li>
                  <button
                    className={styles["mfb-component__button--child"]}
                    onClick={() =>
                      appCtx.handleSelectDivison(3, "sales-customer")
                    }
                  >
                    Konsumen
                  </button>
                </li>
              </ul>
            </li>
          </ul>
        )}
        {appCtx.category === "complain" && (
          <button
            className={styles.button}
            onClick={() => appCtx.handleSelectDivison(3, "sales")}
          >
            Sales
          </button>
        )}
        <button
          className={styles.button}
          onClick={() => appCtx.handleSelectDivison(3, "service")}
        >
          Service
        </button>
      </div>
    </>
  );
};

export default Form;
